import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Coordinates the global "sample data loading" UX so components, dialogs, and the header
 * all stay in sync whenever pull_sample_data runs in the background.
 */
@Injectable({
  providedIn: 'root'
})
export class SampleDataLoadingService {
  private dismissedSubject = new BehaviorSubject<boolean>(false);
  private dismissedFlag = false;

  readonly dismissed$ = this.dismissedSubject.asObservable();

  markDismissed(): void {
    this.dismissedFlag = true;
    this.dismissedSubject.next(true);
  }

  resetDismissal(): void {
    if (!this.dismissedFlag) {
      this.dismissedSubject.next(false);
      return;
    }
    this.dismissedFlag = false;
    this.dismissedSubject.next(false);
  }

  hasUserDismissed(): boolean {
    return this.dismissedFlag;
  }
}
